import Box from "ds/components/Box";
import TabWithCounter from "ds/components/Tab/WithCounter";

import { VendorMigrationTab } from "../types";

type DashboardWidgetsVendorMigrationTabsProps = {
  selectedTab: VendorMigrationTab;
  counts: Record<VendorMigrationTab, number>;
  onSelect: (tab: VendorMigrationTab) => void;
};

const DashboardWidgetsVendorMigrationTabs = ({
  selectedTab,
  counts,
  onSelect,
}: DashboardWidgetsVendorMigrationTabsProps) => (
  <Box gap="medium" padding="small 0 0 0" role="tablist" fullWidth>
    {Object.values(VendorMigrationTab).map((tab) => (
      <TabWithCounter
        key={tab}
        id={tab}
        label={tab}
        count={counts[tab]}
        isActive={selectedTab === tab}
        onClick={onSelect}
      />
    ))}
  </Box>
);

export default DashboardWidgetsVendorMigrationTabs;
